module.exports = require("core-js/modules/es.object.get-own-property-descriptor.js");